// components/access-denied/AccessDenied.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigates to the previous page
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center">
      <h1 className="text-4xl font-bold text-red-600 mb-4">Access Denied</h1>
      <p className="text-lg text-gray-700 mb-8">
        You do not have the necessary permissions to view this page.
      </p>
      <button
        onClick={handleGoBack}
        className="bg-blue-600 hover:bg-blue-700 btn btn-primary py-2 px-4 rounded mt-4"
      >
        Go Back
      </button>
    </div>
  );
};

export default AccessDenied;
